import type { FC } from 'react';

import { Add, MoreHoriz, PersonDefault } from '@shared/assets';
import { IconButton } from '@shared/ui';

import * as st from './styles.module.scss';

export const MessengerDialog: FC = () => {
	return (
		<div className={st.dialog}>
			<div className={st.header}>
				<div className={st.img}>
					<PersonDefault />
				</div>

				<div className={st.title}>FirstName LastName</div>

				<IconButton variant="dark">
					<MoreHoriz />
				</IconButton>
			</div>

			<div className={st.chat}>
				<div className={st.main}></div>
				<div className={st.action}>
					<input type="text" className={st.input} />
					<IconButton variant="dark">
						<Add />
					</IconButton>
				</div>
			</div>
		</div>
	);
};
